import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "../common/common";

export const AuthProtect = () => {
  const auth = getToken();

  if (auth) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
